import {defineMessages} from "react-intl";

const messages = defineMessages({
    editQuota:{
	id:"app.edit-quota-modal.editQuota",
	description:"edit quota modal",
	defaultMessage:"Edit Quota"
    },

    circulationOne:{
	id:"app.edit-quota-modal.circulationOne",
	description:"circulation One",
	defaultMessage:"Schedule 1-Circulation"
    },

    circulationTwo:{
	id:"app.edit-quota-modal.circulationTwo",
	description:"circulation Two",
	defaultMessage:"Schedule 2-Circulation"
    },

    submit:{
	id:"app.edit-quota-modal.submit",
	description:"submit",
	defaultMessage:"Submit"
    },

    reasonDoc:{
	id:"app.edit-quota-modal.reasonDoc",
	description:"submit",
	defaultMessage:"Upload Change Reason Document"
    },

    narcotics:{
	id:"app.edit-quota-modal.narcotics",
	description:"narcotics ",
	defaultMessage:"Schedule 1-Narcotics"
    },

    yes:{
	id:"app.edit-quota-modal.yes",
	description:"yes",
	defaultMessage:"Yes"
    },

    no:{
	id:"app.edit-quota-modal.no",
	description:"no",
	defaultMessage:"No"
    },

    prodNum:{
	id:"app.edit-quota-modal.prodNum",
	description:"prod num",
	defaultMessage:"Product Number"

    },

    prodTradeNum:{
	id:"app.edit-quota-modal.prodTradeNum",
	description:"prod trade num",
	defaultMessage:"Product Trade Name"

    },

    reqAmount:{
	id:"app.edit-quota-modal.reqAmount",
	description:"req amount",
	defaultMessage:"Requested Amount"

    },

    amountApp:{
	id:"app.edit-quota-modal.amountApp",
	description:"amount app",
	defaultMessage:"Amount Approved"
	
    },

    one:{
	id:"app.edit-quota-modal.one",
	description:"one",
	defaultMessage:"1X"
    },

    two:{
	id:"app.edit-quota-modal.two",
	description:"two",
	defaultMessage:"3X"
    },

    specialCase:{
	id:"app.edit-quota-modal.specialCase",
	description:"special case",
	defaultMessage:"Special Case"
    },

    xQuota:{
	id:"app.edit-quota-modal.xQuota",
	description:"x quota",
	defaultMessage:"X Quota*"
    }
    
});


export default messages;
